import * as React from "react"
import Section from "../../../../core/layout/main/section/Section"
import BigQuoteBlock from "../../blocks/big-quote/BigQuoteBlock"

const BigQuoteSection = ({ quote, author }) => {
  return (
    <Section>
      <BigQuoteBlock
        quote={quote}
        author={author}
      />
    </Section>
  )
}

export const name = "BigQuoteSection"

export const init = (componentData, pageContext) => {
  return (
    <BigQuoteSection
      key={componentData.id}
      quote={componentData.quote}
      author={componentData.author}
    />
  )
}

export default BigQuoteSection
